var classes = {
  "accordions": "accordions__Piot6"
};
export { classes as default };